module.exports = {"540424100":"扎木镇","540424101":"倾多镇","540424102":"松宗镇","540424200":"易贡乡","540424201":"玉普乡","540424202":"康玉乡","540424203":"多吉乡","540424204":"玉许乡","540424205":"八盖乡","540424207":"古乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540424.json
// module id = 2856
// module chunks = 0